import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { useMarketplacePage } from '../../../api/hooks/useMarketplace.hook';
import { fetchDetailedInstances, setFilter } from '../../../redux';
import { BasicCardVariants } from '../../../utils/_enums/basic-card-variants.enum';
import { FilterExpression } from '../../../utils/_enums/filter-expression.enum';
import { TypographyVariantsEnum } from '../../../utils/_enums/typeography-variants.enum';
import { useAppSelector } from '../../../utils/_hooks/hooks';
import Teaser from '../../_shared/teaser/teaser';
import TeaserCard from '../../_shared/teaser-card/teaser-card';
import { Typography } from '../../_shared/typography/typography';
import styles from './marketplace-instance-teaser.module.scss';

const MarketplaceInstanceTeaser = () => {
    const dispatch = useDispatch();
    const data = useMarketplacePage();
    const {
        instances,
        filter
    } = useAppSelector((state) => ({
        instances: state.productSlice.detailedInstances,
        filter: state.productSlice.detailedInstances.filter
    }));

    useEffect(() => {
        fetchInstancesWithFilter(0, 24);
    }, [filter]);

    useEffect(() => {
        return () => {
            dispatch(setFilter([...instances.filter.filter(item => (item.param !== 'owner' && item.param !== 'isResale'))]));
        }
    }, []);

    const fetchInstancesWithFilter = (offset: number, pageSize: number) => {
        const currentInstanceFilter = [
            {
                value: pageSize.toString(),
                param: 'size',
                comparisonType: FilterExpression.none
            },
            {
                value: offset.toString(),
                param: 'page',
                comparisonType: FilterExpression.none
            },
            {
                value: 'OPEN',
                param: 'status',
                comparisonType: FilterExpression.equals
            },
            ...filter
        ];
        dispatch(fetchDetailedInstances(currentInstanceFilter));
    };


    if (instances?.data && instances.data.length > 0) {
        return (
            <div className={styles['marketplace-instances-wrapper']}>
                <Teaser
                    headline={''}
                    hideTeaserButtons={true}
                    maxCards={instances.maxNumber}
                    headlineElement={'h2'}
                    headlineVariant={TypographyVariantsEnum.HEADING1}
                    withNumbers={true}
                    pending={instances.pending}
                    pagination={instances.pagination}
                    cards={instances.data.map((instance) => (
                        <TeaserCard key={`marketplace-instance-${instance.id}`} instance={instance}/>
                    ))}
                    onLoadNewItems={(data) => {
                        fetchInstancesWithFilter(data.pageOrOffset, data.size);
                    }}
                    type={BasicCardVariants.BASIC_CARD_SMALL}
                />
            </div>
        );
    } else {
        return <Typography className={styles['no-instances-message']}>{data.noItemsWithFilter}</Typography>
    }
}

export default MarketplaceInstanceTeaser;
